const is = require('is_js');

/**
 * Detects relevant aspects of browser and operating system.
 * @type {{}}
 */
const detect = {

    /**
     * Detects MSIE
     * @returns {Boolean}
     */
    ie() {
        return is.ie();
    },

    /**
     * Detects Windows (10 if on Windows version 10, otherwise true)
     * @returns {Boolean|Number}
     */
    windows() {
        /*
        Examples of navigator.appVersion
        5.0 (Windows NT 6.1; WOW64; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; .NET4.0C; .NET4.0E; rv:11.0) like Gecko
        5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko
         */
        if (!is.windows()) {
            return false;
        }
        else if (navigator.appVersion.match('Windows NT 10')) {
            return 10;
        }
        else {
            return true;
        }
    },

};

module.exports = detect;
